import React from "react";
import { ShowHide } from "components/layout";
import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from 'prop-types';

export function Recaptcha({ showError, captchaRef }) {
    return (
        <div className="spacer-bottom">
            <div>
                <ReCAPTCHA sitekey={window.env.RECAPTCHASITEKEY} ref={captchaRef} />
            </div>
            <ShowHide
                evaluator={showError}
                show={<div className="spacer-top-small">
                    <p className="form-field-red">
                        *Please complete captcha form
                    </p>
                </div>}
            />

        </div>
    );
}

Recaptcha.propTypes = {
    showError: PropTypes.bool.isRequired,
    captchaRef: PropTypes.object.isRequired
};